import { render } from "./IOS.vue?vue&type=template&id=473306d9&scoped=true"
import script from "./IOS.vue?vue&type=script&lang=js"
export * from "./IOS.vue?vue&type=script&lang=js"

import "./IOS.vue?vue&type=style&index=0&id=473306d9&scoped=true&lang=css"

import exportComponent from "/workspace/goj/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473306d9"]])

export default __exports__